import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'
import RequestCore, { lsGetWithToken } from 'utils/request'

export const useAdvancedFilterItems = (dataSource) => {
  const genUrl = () => {
    try {
      const props = typeof dataSource === 'function' ? dataSource() : dataSource
      if (props === null) {
        return null
      }
      return [
        `/advancedFilterItems?${stringify(props)}`,
        RequestCore.getToken(),
      ]
    } catch (err) {
      return null
    }
  }
  return useCustomSWR(genUrl)
}
